import { Card, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { FileWithPath } from 'react-dropzone';
import { darkNeutral, lightNeutral } from 'src/colors';
import { FileDropzone } from './file-dropzone';

interface Props {
  onFile: (file: File) => void;
  file: FileWithPath;
}

export const DragNDrop: FC<Props> = ({ onFile, file }) => {
  const {
    palette: { mode },
  } = useTheme();

  return (
    <>
      {!file ? (
        <FileDropzone
          loading={false}
          onChange={acceptedFiles => onFile(acceptedFiles[0])}
        />
      ) : (
        <Card
          variant="outlined"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            cursor: 'pointer',
            borderColor:
              mode === 'light' ? lightNeutral[100] : darkNeutral[300],
            borderStyle: 'dashed',
            height: 80,
          }}>
          <Typography>{file.path}</Typography>
        </Card>
      )}
    </>
  );
};
